import { IShipmentData } from '../../../../../../../../types/orders';
import { groupBySku } from '../../../../../../../../utils/groupBySku';
import './CustomModalContentSendProducts.scss';

interface ICustomModalContentSendProducts {
  orderId: number;
  organizationName?: string;
  shipmentPlace?: string;
  shipmentFlag?: string;
  nameCountry?: string;
  listOfGroupedShipments?: IShipmentData[];
  loading?: boolean;
  sendDataProductsToWarehouse: () => void;
}
const CustomModalContentSendProducts = ({
  orderId,
  organizationName = 'Nombre Empresa',
  shipmentPlace = '',
  shipmentFlag,
  nameCountry = '',
  listOfGroupedShipments = [],
  loading,
  sendDataProductsToWarehouse
}: ICustomModalContentSendProducts) => {
  return (
    <div className="customModalContentSendProducts">
      <div className="containerMainSendProducts">
        <div className="titleContentSendProducts">
          <span className="titleContentSendProductsTextInfo">
            {organizationName} - Order N° {orderId}
          </span>
          <div className="line">|</div>
          Envío - {shipmentPlace}
          {!!shipmentFlag && <div className="flagContainer" style={{ backgroundImage: `url(${shipmentFlag})` }} />}
        </div>
        <div className="containerProducts">
          <div className="titleProducts">
            Productos que se enviarán a <span className="bold">.bord Warehouse {nameCountry}</span>
          </div>
          {listOfGroupedShipments.map((shipment, index) => {
            const productsBySku = groupBySku(shipment?.products || []);

            return productsBySku.map(productsInShippingGroup => {
              const shipmentGroup = listOfGroupedShipments[index];
              const firstProductInGroup = productsInShippingGroup[0];
              return (
                <div key={`cardShipment-${shipmentGroup.shipmentId}`} className="cardShipment">
                  <div className="titleShipmentUnitOfTheProducts">
                    Producto {index + 1} de {listOfGroupedShipments?.length}
                  </div>
                  <div className="infoProduct">
                    <div className="nameProduct">{firstProductInGroup?.name}</div>
                    <div className="pills">
                      {!!firstProductInGroup?.pills?.Cargo && (
                        <div className="position">{firstProductInGroup?.pills?.Cargo}</div>
                      )}
                      {!!firstProductInGroup?.pills?.Procesador && (
                        <div className="processor">{firstProductInGroup?.pills?.Procesador}</div>
                      )}
                      {!!firstProductInGroup?.pills?.Memoria && (
                        <div className="memory">{firstProductInGroup?.pills?.Memoria}</div>
                      )}
                    </div>
                    <div className="units">
                      {productsInShippingGroup?.length} {productsInShippingGroup?.length >= 2 ? 'unidades' : 'unidad'}
                    </div>
                  </div>
                </div>
              );
            });
          })}
        </div>
      </div>
      <div className="containerButton">
        <button
          className={`buttonConfirm ${loading ? 'isLoading' : ''}`}
          disabled={loading}
          onClick={sendDataProductsToWarehouse}
        >
          <div className="buttonConfirmText">Confirmar envío a Bodegas</div>
        </button>
      </div>
    </div>
  );
};

export default CustomModalContentSendProducts;
